/*global sp, analyticEventTracker */
const chatBot = {
    cachedConversationId: '',
    messageSent: false,
    chatBotOpened: false,
    chatbotContainer: document.getElementById('zendesk-widget'),
    chatBotLangMap: {
        it: 'ita',
        fr: 'fra',
        de: 'deu',
        es: 'spa',
        pt: 'por'
    },
    init: function() {
        chatBot.loadChatBot();
    },
    loadChatBot() {
        let email = '';

        try {
            email = Object.hasOwn(dataLayer[0], 'user') && Object.hasOwn(dataLayer[0].user, 'email') ? dataLayer[0].user.email : '';
        } catch (e) {
            email = '';
        }

        $.ajax({
            url: _d.url.chatBot,
            type: 'GET',
            dataType: 'json',
            data: ({
                reservationNumber: _d.rn,
                email: btoa(email),
                page: _d.page
            }),
            success: function(data) {

                if (!data.email) {
                    return;
                }

                if (chatBot.chatbotContainer) {
                    let script = document.createElement('script');
                    script.id = 'ze-snippet';
                    script.src = 'https://static.zdassets.com/ekr/snippet.js?key=4533f80d-d606-48a2-8fa7-6e9d3c1b74f5';
                    script.onload = function() {
                        const mappedLang = chatBot.chatBotLangMap[_d.s.language] || 'en';

                        let checkZendesk = setInterval(function() {
                            if (typeof window.zE !== 'undefined') {
                                clearInterval(checkZendesk);
                                window.zE('messenger:set', 'conversationFields', [
                                    { id: '6237438156049', value: data.reservationNumber },
                                    { id: '34039656782737', value: data.email },
                                    { id: '34227795551121', value: mappedLang }
                                ]);
                                chatBot.listenToWidget(data);
                            }
                        }, 500);
                    };

                    chatBot.chatbotContainer.append(script);
                }
            }
        });
    },
    listenToWidget() {
        window.zE('messenger:set', 'locale', _d.s.language);
        window.zESettings = {
            webWidget: {
                locale: _d.s.language,
                chat: {
                    suppress: false,
                    metadata: {
                        language: _d.s.language
                    }
                }
            }
        };
        window.zE('messenger:on', 'open', function() {
            const eventData = {
                eventName: 'ChatBot_Opened',
                attributes: {
                    'attributePageSource': _d.page
                }
            };

            analyticEventTracker.trackEvent(eventData);
            chatBot.chatBotOpened = true;
        });
    }
};
